"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ColumnDataType;

(function (ColumnDataType) {
  ColumnDataType["STRING"] = "string";
  ColumnDataType["NUMERIC"] = "numeric";
  ColumnDataType["BOOLEAN"] = "boolean";
  ColumnDataType["DATE"] = "date";
  ColumnDataType["DATE_TIME"] = "datetime";
  ColumnDataType["DATE_TIME_UTC"] = "datetimeutc";
})(ColumnDataType = exports.ColumnDataType || (exports.ColumnDataType = {}));

var ColumnSortDirection;

(function (ColumnSortDirection) {
  ColumnSortDirection["NONE"] = "None";
  ColumnSortDirection["ASCENDING"] = "Ascending";
  ColumnSortDirection["DESCENDING"] = "Descending";
})(ColumnSortDirection = exports.ColumnSortDirection || (exports.ColumnSortDirection = {}));

var CompareOperators;

(function (CompareOperators) {
  CompareOperators["NONE"] = "None";
  CompareOperators["AUTO"] = "Auto";
  CompareOperators["EQUALS"] = "Equals";
  CompareOperators["NOT_EQUALS"] = "NotEquals";
  CompareOperators["CONTAINS"] = "Contains";
  CompareOperators["STARTS_WITH"] = "StartsWith";
  CompareOperators["ENDS_WITH"] = "EndsWith";
  CompareOperators["GTE"] = "Gte";
  CompareOperators["GT"] = "Gt";
  CompareOperators["LTE"] = "Lte";
  CompareOperators["LT"] = "Lt";
  CompareOperators["MULTIPLE"] = "Multiple";
  CompareOperators["BETWEEN"] = "Between";
  CompareOperators["NOT_CONTAINS"] = "NotContains";
  CompareOperators["NOT_STARTS_WITH"] = "NotStartsWith";
  CompareOperators["NOT_ENDS_WITH"] = "NotEndsWith";
})(CompareOperators = exports.CompareOperators || (exports.CompareOperators = {}));

var AggregateFunctions;

(function (AggregateFunctions) {
  AggregateFunctions["NONE"] = "None";
  AggregateFunctions["SUM"] = "Sum";
  AggregateFunctions["AVERAGE"] = "Average";
  AggregateFunctions["COUNT"] = "Count";
  AggregateFunctions["DISTINCT_COUNT"] = "DistinctCount";
  AggregateFunctions["MAX"] = "Max";
  AggregateFunctions["MIN"] = "Min";
})(AggregateFunctions = exports.AggregateFunctions || (exports.AggregateFunctions = {}));